import {User} from '../../model/shared/user/user';
import {BaseResponse} from '../internal/baseresponse';
export class ADMLoginResult extends BaseResponse {
  data: User;
}



// WEBPACK FOOTER //
// ./src/app/response/admin/admloginresult.ts